import React, { useState } from "react";
import { Col, Typography } from "antd";
import { ReactComponent as AlertInfoIcon } from "../../../assets/icons/icon.svg";
import { ReactComponent as AiStarIcon } from "../../../assets/icons/Aistar.svg";
const { Text } = Typography;
const QuotesBanner = ({
  item,
  handleAcceptedQuote,
  auto_generated,
  idx,
  
}) => {
  const isMagicQuote =
    item?.quote_status === "Magic Quote" ||
    item?.is_magic_quote === true;
    

  const [
    bannerShow,
    //  setBannerShow
  ] = useState(true);

  const handleBannerRemove = () => {
    // setBannerShow(false);
    handleAcceptedQuote(item);
  };
  return (
    <>
      {bannerShow && (
        <Col>
          {isMagicQuote && (
            <Col
              style={{
                background: "linear-gradient(to left, #fff0bd, #f8c194)",
                padding: "12px 11px",
                borderRadius: "10px 10px 0 0",
                display: "flex",
                alignItems: "center",
                gap: "12px",
              }}
            >
              <AiStarIcon />
              <Text style={{ color: "#0a243f", fontWeight: 600 }}>
                AI generated quote. Duplicate to edit and share final quote
              </Text>
            </Col>
          )}
          {item?.quote_status !== "Published" &&
            !isMagicQuote && (
            <>
              {item?.items >= 0 &&
              (item?.quote_status === "Accepted" ||
                item?.quote_status === "Order Created" ||
                item?.quote_status === "Order Converted") ? (
                <>
                  <Col
                    style={{
                      backgroundColor: "#4fb589",
                      padding: "12px 11px",
                      borderRadius: "10px 10px 0 0",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Text style={{ color: "#ffffff", fontWeight: 500 }}>
                      {item?.quote_status === "Accepted"
                        ? `Quotation accepted by customer`
                        : `Quote ${item?.index} converted to order`}
                    </Text>

                    {item?.quote_status === "Accepted" && (
                      <Text
                        style={{
                          color: "#ffffff",
                          fontWeight: 500,
                          borderBottom: "1px solid",
                          height: "20px",
                          cursor: "pointer",
                        }}
                        onClick={handleBannerRemove}
                      >
                        Remove
                      </Text>
                    )}
                  </Col>
                </>
              ) : (
                <>    
                 {item?.hsn_not_available > 0 && (
                    <Col
                      style={{
                        backgroundColor: "#ffebe6",
                        padding: "12px 11px",
                        borderRadius: "10px 10px 0 0",
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <AlertInfoIcon />
                      <Text style={{ color: "#f0483e", fontWeight: 500 }}>
                        Please update HSN/ SAC to publish
                      </Text>
                    </Col>
                  )} 
                {auto_generated && item.auto_generated && idx===0 ?(
                  <>
                  <Col
                        style={{
                          backgroundColor: "#ffebe6",
                          padding: "12px 11px",
                          borderRadius: "10px 10px 0 0",
                          display:"flex",
                          alignItems:"center",
                          gap:"16px"
                        }}
                      >
                        <AlertInfoIcon/>
                        <Text style={{ color: "#f0483e", fontWeight: 500 }}>
                      
                        This is an auto generated quote. Please update price and BMP to publish
                        </Text>
                      </Col>
                  </>
                ):(     
                  <>    
                  {item?.mob_all_bmp &&
                    item?.items > 0 && (
                      <Col
                        style={{
                          backgroundColor: "#9da7b2",
                          padding: "12px 11px",
                          borderRadius: "10px 10px 0 0",
                        }}
                      >
                        <Text style={{ color: "#ffffff", fontWeight: 500 }}>
                        Change the BMP to publish quote
                        </Text>
                      </Col>
                  )}
                    </>
                  )}  
                </>
              )}
            </>
          )}
        </Col>
      )}
    </>
  );
};

export default QuotesBanner;
